<template>
  <div>
    <dealer-base />
  </div>
</template>
<script>
import DealerBase from '../components/user-management/dealer/DealerBase.vue';

export default {
  name: 'UserManagement',
  components: {
    DealerBase,
  },
  mounted() {
    this.$_introUserManage();
  },
};
</script>
